import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import LoaderIcon from '@/components/Common/LoaderIcon';
import { resetCatalogsList } from '../../../../../../redux/actions';
import { getProducts } from '../../../MiddleBody5/utils';
import {
  CategoriesItemsContainer,
  CategoriesWrapper,
  CategoryListWrapper,
  CategoryName,
} from './AllCategoriesItems.styles';
import { useSSRSelector } from '@/redux/ssrStore';
import { ProductListWrapper } from 'src/components/DesignSystem/Widgets2.0/ProductListWrapper';
import useOnScreen from 'src/hooks/useOnScreen';
import { getThemeColor } from 'src/utils/getThemeColor';

function AllCategoriesItems(props) {
  const dispatch = useDispatch();
  const { catalog_items } = useSelector((state: any) => ({
    catalog_items: state.catalogReducer.catalog_items,
  }));
  const {
    storeData: { store_id },
    categories,
  } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
    categories: state.catalogReducer.categories,
  }));
  /**
   * the following data has been kept in useRef for the purpose of
   * synchronous data manipulation
   */

  /**
   * categoryPaginationStatus : it holds data for each category if its nextPage
   * is there and array for page number for which the api has been called
   */
  const categoryPaginationStatus = useRef({});

  /**
   * categoryPaginationIterator : its an Iterator to change category nextPage To true
   * when the one category is full rendered and we need to render the next category
   */
  // const categoryPaginationIterator = useRef(0);

  /**
   * categoryIdArray : contains categoryId's
   */
  const categoryIdArray = useRef([]);

  /**
   * loader : used to control pagination api. if one api is called till its
   * execution is not done loader will not change state and critical section of code
   * is not invoked
   */
  const loader = useRef({});

  /**
   * initializing categoryIdArray and categoryPaginationStatus
   */
  useEffect(() => {
    const tempCategoryPaginationStatus = {};
    categories &&
      !!categories?.length &&
      categories.forEach((item, index) => {
        const tempStatusObj = {};
        tempStatusObj['isNext'] = index === 0 ? true : false;
        tempStatusObj['pages'] = [0];
        tempCategoryPaginationStatus[item.id] = tempStatusObj;
      });
    categoryPaginationStatus.current = tempCategoryPaginationStatus;
    categories &&
      !!categories?.length &&
      categories.forEach((item) => {
        categoryIdArray.current.push(item?.id);
      });

    return () => {
      dispatch(resetCatalogsList());
    };
  }, [categories]);

  /**
   * @param {number} categoryId
   * @return {number} page number for api.
   */
  function categoryPageNumber(categoryId) {
    return (
      categoryPaginationStatus.current[categoryId]?.pages?.[
      categoryPaginationStatus.current[categoryId]?.pages?.length - 1
      ] + 1
    );
  }

  /**
   * loads data / is invoked when user Scroll end
   * @param {number} categoryId
   */
  async function loadMoreDataCategories(categoryId) {
    const pageNo = categoryPageNumber(categoryId);
    /** if loader is not there isNExt for category is true and pageNumber api is never called then call api */
    if (
      !loader.current?.[categoryId] &&
      !categoryPaginationStatus.current[categoryId]?.pages?.includes(pageNo)
    ) {
      loader.current[categoryId] = true;
      if (!store_id) return;
      const { status, isNextPage } = await getProducts(
        categoryId,
        categoryId?.hasOwnProperty('is_custom_tag') ? 1 : 0,
        pageNo,
        store_id
      );
      if (status) {
        categoryPaginationStatus.current[categoryId]?.pages?.push(pageNo);
        categoryPaginationStatus.current[categoryId]['isNext'] = isNextPage
      }
    }
    loader.current[categoryId] = false;
  }

  /**
   *
   * @param {number} categoryId
   * @return {object} category data that needs to be rendered.
   */

  function returnNestedCategoryData(categoryId) {
    let categoryIdValue = undefined;
    categoryIdValue = catalog_items[categoryId];
    return categoryIdValue;
  }

  return (
    <CategoriesWrapper
      showFilterDrawer={props?.showFilterDrawer}
      showSortByDropDown={props?.showSortByDropDown}
    >
      {categories?.map((category) => (
        <CategorySection
          key={category.id}
          category={category}
          loadMoreDataCategories={loadMoreDataCategories}
          returnNestedCategoryData={returnNestedCategoryData}
          categoryPaginationStatus={categoryPaginationStatus}
          loader={loader}
          catalog_items={catalog_items}
        />
      ))}
    </CategoriesWrapper>
  );
}

export default AllCategoriesItems;

const CategorySection = ({
  category,
  loadMoreDataCategories,
  returnNestedCategoryData,
  categoryPaginationStatus,
  loader,
  catalog_items
}) => {
  const themeColor = getThemeColor();
  const ref = useRef();
  const hasLoaded = useRef(false);

  const isVisible = useOnScreen(ref, { threshold: 0.1 });

  useEffect(() => {
    if (isVisible && !hasLoaded.current && !catalog_items?.[category.id]) {
      loadMoreDataCategories(category.id);
      hasLoaded.current = true;
    }
  }, [isVisible, catalog_items]);

  return (
    <div>
      <CategoryListWrapper key={category?.id}>
        <CategoryName ref={ref}>{category.name}</CategoryName>
        <CategoriesItemsContainer>
          <ProductListWrapper
            productList={returnNestedCategoryData(category.id)}
            calculateSelfDimensions
            renderAdvancedCard
            oldCardConfigs={{
              showButton: true,
              noTagsReadState: 'fromLength',
            }}
            customClass="tw-mt-[24px]"
          />
          {categoryPaginationStatus.current[category?.id]?.isNext && !loader?.current?.[category.id] && (
            <div className='tw-w-full tw-flex tw-justify-center'>
              <div
                onClick={() => loadMoreDataCategories(category.id)}
                style={{ borderColor: themeColor, color: themeColor }}
                className={'sm:tw-w-full tw-w-[100px] tw-cursor-pointer tw-mt-24 tw-mb-34 tw-mx-8 tw-border tw-border-solid tw-py-12 tw-text-center tw-text-14 tw-font-medium'}>
                View More
              </div>
            </div>
          )}
          {/* {categoryPaginationStatus.current[category?.id]?.isNext &&
            !isFullCatalogLoaded &&
            loader.current?.[category?.id] && (
              <div className="flex justify-center mt4 relative">
                <GlobalCfeLoader
                  type={globalStyle?.appLoader?.loaderId || 'ellipsis'}
                  color={globalStyle?.appLoader?.color}
                />
              </div>
            )} */}
        </CategoriesItemsContainer>
      </CategoryListWrapper>
    </div>
  );
};

